export default "__VITE_ASSET__DGwth37d__"